module.exports = {
  i18n: {
    locales: ["en", "uz", "ru"],
    defaultLocale: "uz",
    localeDetection: false,
  },
  reloadOnPrerender: process.env.NODE_ENV === "development",
  localePath:
    typeof window === "undefined"
      ? require("path").resolve("./public/locales")
      : "/locales",
};
